<script context="module">
    export function getPID(patientInfo, encounterInfo) {
        let patientSidePID = "";
        if (
            patientInfo &&
            patientInfo.insurance &&
            patientInfo.insurance.includes("|")
        ) {
            patientSidePID =
                patientInfo.insurance.substring(
                    0,
                    patientInfo.insurance.indexOf(" | "),
                ) ?? "";
        }
        let encounterSidePID =
            encounterInfo?.patientEncounterDefenceData?.pid ?? "";

        if(encounterSidePID)
            return encounterSidePID;
        return patientSidePID
    }

    export function getDAN(patientInfo, encounterInfo) {
        let patientSideDAN = "";
        if (
            patientInfo &&
            patientInfo.insurance &&
            patientInfo.insurance.includes("|")
        ) {
            patientSideDAN =
                patientInfo.insurance.substring(
                    patientInfo.insurance.indexOf(" | ") + 3,
                ) ?? "";
        }
        let encounterSideDAN =
            encounterInfo?.patientEncounterDefenceData?.dan ?? "";

        if(encounterSideDAN)
            return encounterSideDAN;
        return patientSideDAN;
    }
</script>
